import { useMutation, UseMutationOptions } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'

interface GenerateLogResponseData {
  url: string
}

const ZERO_WEB_URL =
  process.env.REACT_APP_ZERO_WEB_URL || 'http://localhost:3000'

const fetchGenerateZeroLogInUrl = async (userUuid: string) => {
  let response = await fetch(
    `${BASE_API_URL}/admin/api/v1/users/${userUuid}/log_in_url/create`,
    {
      method: API_METHODS.POST,
      headers: apiHeaders(store.getState()),
    }
  )
  response = handleErrors(response)
  const json: GenerateLogResponseData = await response.json()

  // Extract auth params from Bloop URL and construct Zero URL
  const bloopUrl = new URL(json.url)
  const authCode = bloopUrl.searchParams.get('auth_code')
  const authConfirmationUuid = bloopUrl.searchParams.get(
    'auth_confirmation_uuid'
  )

  // Construct Zero Web URL
  const zeroUrl = `${ZERO_WEB_URL}/login?auth_code=${authCode}&auth_confirmation_uuid=${authConfirmationUuid}&show_logged_in_as=true`

  return { url: zeroUrl }
}

type MutationOptions = UseMutationOptions<
  GenerateLogResponseData,
  unknown,
  string
>

const useMutationAdminGenerateZeroLogInUrl = (
  sideEffectsObject: Partial<MutationOptions>
) => {
  return useMutation(
    (userUuid: string) => {
      return fetchGenerateZeroLogInUrl(userUuid)
    },
    {
      ...sideEffectsObject,
      onError: (e) => {
        console.error(e)
        alert(
          'Uh oh! There was an error! Check the console. Take a screenshot and send to engineers.'
        )
      },
    }
  )
}

export default useMutationAdminGenerateZeroLogInUrl
